import { SxStyles } from '../../../../../../../types';
import theme from '../../../../../../../theme';
import { getResponsiveSize } from '../../../../../../../utils';

export const AudioUploadStyle: SxStyles = {
  videoTabContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',

    '& .video-type-switch': {
      width: '100%',
      // mb: `calc(${theme.palette.propVars?.index} * 0.555)`,
      justifyContent: 'space-between',
      '& .mask-box ': {
        '& .MuiButton-root': {
          '& svg': {
            '&.union': {
              fill: theme.palette.neutral?.grey50,
            },
            '& .border': {
              stroke: theme.palette.neutral?.grey50,
            },
            '& .play': {
              fill: theme.palette.neutral?.grey50,
            },
          },
          '&.active': {
            color: theme.palette.neutral?.black,
            '& svg': {
              '&.union': {
                fill: theme.palette.neutral?.black,
              },
              '& .border': {
                stroke: theme.palette.neutral?.black,
              },
              '& .play': {
                fill: theme.palette.neutral?.black,
              },
            },
          },
        },
        '& .mask': {
          width: `calc(${theme.palette.propVars?.index} * 4.51)`,
        },
      },
    },

    '& .audio-container': {
      pt: `calc(${theme.palette.propVars?.index} * 1.5)`,
      // width: getResponsiveSize(468),
      height: getResponsiveSize(258),

      '& iframe': {
        borderRadius: theme.palette.propVars?.borderRadius,
      },
      '& .audio-uploaded': {
        '& .uploaded-text': {
          textTransform: 'capitalize',
          color: theme.palette.neutral?.greyRGBA80,
          fontFamily: theme.typography.mainFontFamily,
          fontSize: getResponsiveSize(20),
          fontWeight: '400',
        },
      },
    },
  },
};
